<div class="conversationView">
    <vng-chat class="w-100"></vng-chat>
</div>